export default __webpack_public_path__ + "static/media/CarlosDomingo.ecea410e.jpeg";